import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class ImageUploadComponent implements IController {
  url: any;
  type: any;
  size: any;
  disableUpload: any;
  onUpload: Function;

  loading: boolean = false;
  isPdf: boolean;

  constructor() {
  }

  $onInit() {
    this.isPdf = (this.type === 'application/pdf');
  };

  $onChanges(changes) {
    if (changes.url && !changes.url.isFirstChange()) {
      this.$onInit();
    }
  };

  onStartUpload() {
    this.loading = true;
  }

  afterUpload(result) {
    this.loading = false;
    this.onUpload({url: _.get(result, 'data.url')})

    // var reader = new FileReader();
    //
    // reader.onload = function(event) {
    //     ctrl.loading = false;
    //     var url = event.target.result;
    //     ctrl.onUpload({url: url});
    // };
    //
    // reader.readAsDataURL(result.data);
  }

}

angular
  .module('bringoz.admin.commons')
  .component('imageUpload', {
    bindings: {
      url: '<',
      type: '<?',
      size: '<?',
      disableUpload: '<?',
      onUpload: '&'
    },
    templateUrl: 'app/modules/commons/components/image-upload/image-upload.html',
    controller: ImageUploadComponent
  });
